import { UseQueryResult } from '@tanstack/react-query'
import dayjs from 'dayjs'
import { Card, CardBody, OverlayTrigger, Popover } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import MaterialIcon from '../../components/MaterialIcon'
import { Intervento } from '../../types'
import { getLabelStatoIntervento, getLabelTipoIntervento, useIsCliente } from '../../utils/utils'

interface CardStoricoInterventiBilanciaInterface {
  storico_interventi?: {
    id: Intervento['id']
    data_intervento?: Intervento['data_intervento']
    tipo_intervento: Intervento['tipo_intervento']
    stato: Intervento['stato']
    esito: Intervento['esito']
    numero_pratica_esportazione?: Intervento['numero_pratica_esportazione']
    data_stimata_db_precedente?: Intervento['data_stimata_db_precedente']
  }[]
}

type CardStoricoInterventiBilanciaProps = {
  bilancia: UseQueryResult<CardStoricoInterventiBilanciaInterface, Error>
}

export default function CardStoricoInterventiBilancia({ bilancia }: CardStoricoInterventiBilanciaProps) {
  // TODO: controllare come mai intervento non usato
  // const [intervento, setIntervento] = useState<Intervento | null>(null)
  const isCliente = useIsCliente()
  return (
    <Card className="mt-3 mb-3">
      <CardBody>
        <div className="py-1 border-bottom">
          <div className="d-flex justify-content-between">
            <h4 className="heading-h4 d-flex align-items-center">
              <span className="material-icons text-secondary me-2">history</span>
              Storico interventi
            </h4>
          </div>
        </div>
        <div className="mt-3">
          <table className="table">
            <thead>
              <tr>
                <th>Id</th>
                <th>Data</th>
                <th>Tipo</th>
                <th>Stato</th>
                <th>Esito</th>
                {!isCliente && <th>N° pratica</th>}
              </tr>
            </thead>
            <tbody>
              {bilancia.data?.storico_interventi?.map((intervento) => (
                <tr key={intervento.id}>
                  <td>
                    <Link to={`/interventi/${intervento.id}`} className="link-md text-body-secondary">
                      {intervento.id}
                    </Link>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      {intervento.data_intervento ? dayjs(intervento.data_intervento).format('DD.MM.YYYY') : '-'}
                      {!isCliente && intervento?.data_stimata_db_precedente && (
                        <OverlayTrigger
                          trigger="click"
                          overlay={
                            <Popover id="popover-basic">
                              <Popover.Body>
                                <div>
                                  Data stimata: {dayjs(intervento.data_stimata_db_precedente).format('DD.MM.YYYY')}
                                </div>
                                <div>
                                  Data db:{' '}
                                  {intervento.data_intervento
                                    ? dayjs(intervento.data_intervento).format('DD.MM.YYYY')
                                    : '-'}
                                </div>
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <div
                            className="ms-2 pointer"
                            onClick={() => {
                              // TODO: controllare perchè non usato
                              // setIntervento(intervento)
                            }}
                          >
                            <MaterialIcon icon="info" title="Data stimata da DB precedente" />
                          </div>
                        </OverlayTrigger>
                      )}
                    </div>
                  </td>
                  <td>{getLabelTipoIntervento(intervento.tipo_intervento)}</td>
                  <td>{getLabelStatoIntervento(intervento.stato)}</td>
                  <td>
                    {intervento.esito !== '' ? (
                      <>
                        {intervento.esito === 'positivo' ? (
                          <span className="material-icons text-success">check</span>
                        ) : (
                          <span className="material-icons text-danger">close</span>
                        )}
                      </>
                    ) : (
                      '-'
                    )}
                  </td>
                  {!isCliente && (
                    <td>{intervento.numero_pratica_esportazione ? intervento.numero_pratica_esportazione : '-'}</td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardBody>
    </Card>
  )
}
